import { render, staticRenderFns } from "./SopPurpose.vue?vue&type=template&id=706afb16&scoped=true&"
import script from "./SopPurpose.vue?vue&type=script&lang=ts&"
export * from "./SopPurpose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706afb16",
  null
  
)

export default component.exports